import { Alert, AlertTitle, Grid, Stack, Typography, useTheme } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import useDrawerContext from 'v2/components/Drawer/useDrawerContext';
import Loader from 'v2/components/Loader/Loader';
import useDeviceGroupsInfo from 'v2/hooks/useDeviceGroupsInfo/useDeviceGroupsInfo';
import { getDeviceGroupPath } from 'v2/paths';
import EditDeviceGroupsDrawer from '../drawers/EditDeviceGroupsDrawer/EditDeviceGroupsDrawer';
import GroupCard from './GroupCard';

interface Props {
  deviceId: string;
}

const DeviceGroupsCard: React.FC<Props> = ({ deviceId }) => {
  const { translation } = useTranslation();
  const theme = useTheme();
  const { openDrawer } = useDrawerContext();
  const navigate = useNavigate();
  const deviceGroupsInfo = useDeviceGroupsInfo(deviceId);

  if (deviceGroupsInfo.isLoading)
    return (
      <Grid width="100%" height="100%" justifyContent="center" alignItems="center">
        <Loader />
      </Grid>
    );

  const { deviceGroups, isDeviceAccessible } = deviceGroupsInfo;

  const emptyAlert = isDeviceAccessible ? (
    <Typography variant="body2" color="textSecondary">
      {translation.not_assigned_to_device_groups}
    </Typography>
  ) : (
    <Alert variant="standard" severity="error" sx={{ backgroundColor: theme.custom.status.error.selected }}>
      <Stack direction="column">
        <AlertTitle style={{ color: theme.palette.error.light }}>{translation.no_device_groups_assigned}</AlertTitle>
        <Typography variant="body2" style={{ color: theme.palette.error.light }}>
          {translation.add_to_device_group_or_user_group}
        </Typography>
      </Stack>
    </Alert>
  );

  return (
    <GroupCard
      title={translation.device_groups}
      groups={deviceGroups}
      editButtonId="editDeviceGroups"
      emptyAlert={deviceGroups.length === 0 ? emptyAlert : undefined}
      onGroupClick={(id) => navigate(getDeviceGroupPath(id))}
      onEditClick={() => openDrawer(<EditDeviceGroupsDrawer deviceId={deviceId} />)}
    />
  );
};

export default DeviceGroupsCard;
